import { camelCase } from 'lodash';
var convertStatusToTelescriptValue = function (status, cmsSuffix, telescript) {
    var convertedValue = telescript === null || telescript === void 0 ? void 0 : telescript["".concat(camelCase(status)).concat(cmsSuffix)];
    return String(convertedValue !== null && convertedValue !== void 0 ? convertedValue : status);
};
export default convertStatusToTelescriptValue;
